import { render } from "./InputCourse.vue?vue&type=template&id=a771c7ae&scoped=true"
import script from "./InputCourse.vue?vue&type=script&lang=js"
export * from "./InputCourse.vue?vue&type=script&lang=js"

import "./InputCourse.vue?vue&type=style&index=0&id=a771c7ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a771c7ae"]])

export default __exports__